import { Component } from '@angular/core';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { NAV_ITEMS, NavItem } from '../../core/navigation/nav-items';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, ToolbarComponent, FooterComponent, RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  readonly navItems: NavItem[] = NAV_ITEMS.filter((i) => !i.hide);
  trackByNav = (_: number, item: NavItem) => item.route + '|' + item.label;
}
